import { InferType, object } from 'yup';
import { Nullable } from '../../../model/common';
import { safeString } from './common';

export const forgotPasswordSchema = object({
    username: safeString().required('Username cannot be empty!')
});

export type ForgotPasswordFormValues = InferType<typeof forgotPasswordSchema>;
export type ForgotPasswordFormInput = Nullable<ForgotPasswordFormValues>;
